import { createMMKV } from 'react-native-mmkv';
export const MMKVStorage = createMMKV();
